import { Box, Typography, styled } from "@mui/material";

export const SectionContainer = styled(Box)`
  padding: 60px 20px;
  background-color: #fff;
  text-align: center;
  height: 575px;

  @media screen and (max-width: 1245px) {
    height: 100%;
  }

  @media screen and (max-width: 768px) {
    padding: 60px 0;
  }
`;

export const StepsContainer = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 40px;
  gap: 40px;
`;

export const StepCard = styled(Box)`
  width: 374px;
  min-height: 347px;
  text-align: center;
  background-color: #f4f7fa;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
`;

export const IconWrapper = styled(Box)`
  width: 128px;
  height: 128px;
  margin: 0 auto 16px;
  background-color: #da1944;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 54px;
    height: 54px;
  }
`;

export const StepTitle = styled(Typography)`
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 16px;
  color: #333;
`;

export const StepDescription = styled(Typography)`
  font-size: 14px;
  color: #666;
`;
